import PropTypes from 'prop-types';

import MillesimaLink from '@/components/common/MillesimaLink';
import { getProductPageRedirectionInfos } from '@/utils/productCardUtils';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

import styles from './ProductCardName.module.scss';

const ProductCardName = ({ index, product, currentItem, storeConf }) => {
  const isMobile = useScreenSizeContext().isMobile;

  return (
    <div className={styles.container} data-id={`product${index}-goToProductFromListingName`} data-rbf={`${product.productName}`}>
      <MillesimaLink
        type="inline-link"
        ariaLabel={product.productName}
        innerHtml={product.productName}
        size={isMobile ? 'medium' : 'large'}
        {...getProductPageRedirectionInfos(product, currentItem, storeConf)}
      />
    </div>
  );
};

ProductCardName.propTypes = {
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  product: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    seoKeyword: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired
  }).isRequired,
  currentItem: PropTypes.shape({
    partnumber: PropTypes.string
  }).isRequired,
  storeConf: PropTypes.object.isRequired
};

export default ProductCardName;
